module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/chefs_choice--xxl@1x-b57fa3b92d8e8b6e5294f3ff3bd413a8.png";